import { LOCALE } from './constants.js';

const EUR = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DATE = new Intl.DateTimeFormat(LOCALE, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'Europe/Rome',
});

/** Formatta un importo in euro (es. `1.234,56 €`). */
export function formatEuro(value) {
  return EUR.format(Number(value) || 0);
}

/** Formatta una data ISO (es. `7 luglio 2026`). */
export function formatDateISO(isoStr) {
  if (!isoStr) return '';
  return DATE.format(new Date(isoStr));
}

/** Restituisce lo stringa EUR formattata ma senza simbolo € (opzionale). */
export function formatEuroNumeric(value) {
  return EUR.format(Number(value) || 0);
}
